import { combineReducers } from "redux-immutable";
import { connectRouter } from "connected-react-router/immutable";

import {
  confirmationReducer,
  notificationReducer,
} from "altus-redux-middlewares";

import { modalReducer } from "altus-modal";
import { dataStateReducer } from "altus-datastate";

import appReducer from "app/app.reducer";
import formReducer from "app/reducers/form.reducer";
import reportReducer from "features/planner/report/report.reducer";
import viewReducer from "features/planner/reducers/view.reducer";
import cardsReducer from "features/planner/reducers/cards.reducer";
import groupsReducer from "features/planner/reducers/groups.reducer";
import npdReducer from "features/planner/reducers/facilities.reducer";
import markerReducer from "features/planner/reducers/marker.reducer";
import cardMovesReducer from "features/planner/reducers/cardMoves.reducer";
import viewGroupsReducer from "features/planner/reducers/viewGroups.reducer";
import qualificationsReducer from "features/planner/reducers/qualifications.reducer";
import crewsReducer from "features/planner/reducers/crews.reducer";
import countriesReducer from "features/planner/reducers/countries.reducer";
import companyReducer from "features/planner/reducers/company.reducer";
import replaceableEmployeesReducer from "features/planner/reducers/replaceableEmployees.reducer";
import searchReducer from "features/planner/reducers/search.reducer";
import deploymentDetailsReducer from "features/planner/reducers/deploymentDetails.reducer";
import usersReducer from "features/planner/reducers/users.reducer";
import workSchedulesReducer from "features/planner/reducers/workSchedules.reducer";
import workScheduleOverridesReducer from "features/planner/reducers/workScheduleOverrides.reducer";
import webSocketReducer from "features/planner/reducers/webSocket.reducer";
import employeeGroupsReducer from "features/planner/reducers/employeeGroups.reducer";
import employeeCoursesReducer from "features/planner/reducers/employeeCourses.reducer";
import cardCompetencyStatusReducer from "features/planner/reducers/cardCompetencyStatus.reducer";
import workDaysReducer from "features/planner/reducers/workDays.reducer";
import dashboardReducer from "features/planner/reducers/dashboard.reducer";
import projectsReducer from "features/planner/reducers/projects.reducer";

export default history =>
  combineReducers({
    app: appReducer,
    form: formReducer,
    modal: modalReducer,
    report: reportReducer,
    dataState: dataStateReducer,
    router: connectRouter(history),
    confirmation: confirmationReducer,
    notification: notificationReducer,
    view: viewReducer,
    cards: cardsReducer,
    groups: groupsReducer,
    npd: npdReducer,
    markers: markerReducer,
    cardMoves: cardMovesReducer,
    viewGroups: viewGroupsReducer,
    qualifications: qualificationsReducer,
    crews: crewsReducer,
    countries: countriesReducer,
    company: companyReducer,
    replaceableEmployees: replaceableEmployeesReducer,
    search: searchReducer,
    deploymentDetails: deploymentDetailsReducer,
    users: usersReducer,
    workSchedules: workSchedulesReducer,
    workScheduleOverrides: workScheduleOverridesReducer,
    webSocket: webSocketReducer,
    employeeGroups: employeeGroupsReducer,
    employeeCourses: employeeCoursesReducer,
    cardCompetencyStatus: cardCompetencyStatusReducer,
    workDays: workDaysReducer,
    dashboard: dashboardReducer,
    projects: projectsReducer,
  });
